// src/components/PendingScreen.jsx
import React from "react";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import { SCHOOL } from "../config";

export default function PendingScreen({ rejected = false }) {
  const navigate = useNavigate();

  async function logout() {
    await signOut(auth);
    navigate("/login");
  }

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center",
                  justifyContent: "center", background: "#FBF0E8", padding: "24px" }}>
      <div style={{ background: "white", borderRadius: "20px",
                    padding: "48px 40px", maxWidth: "440px", width: "100%",
                    textAlign: "center",
                    boxShadow: "0 4px 24px rgba(123,21,21,.12)" }}>

        <div style={{ fontSize: "3.5rem", marginBottom: "16px" }}>
          {rejected ? "❌" : "⏳"}
        </div>

        <h2 style={{ fontSize: "1.4rem", fontWeight: "800",
                     color: "#1F2937", marginBottom: "10px" }}>
          {rejected ? "Registration Not Approved" : "Application Under Review"}
        </h2>

        <p style={{ color: "#6B7280", fontSize: ".92rem",
                    lineHeight: 1.75, marginBottom: "24px" }}>
          {rejected
            ? "Unfortunately your registration was not approved. Please contact us for more details or to reapply."
            : "Your registration has been submitted and is being reviewed by our team. You will be notified once your account is activated — this usually takes 1–2 business days."}
        </p>

        <div style={{ background: "#FBF0E8", borderRadius: "12px",
                      padding: "16px 20px", marginBottom: "28px",
                      fontSize: ".88rem", color: "var(--purple-text)", lineHeight: 2.1,
                      textAlign: "left" }}>
          <div style={{ fontWeight: "700", marginBottom: "2px" }}>Need help? Reach us at:</div>
          <div>📞 {SCHOOL.phone}</div>
          <div>📧 {SCHOOL.email}</div>
          <div>📍 {SCHOOL.address}</div>
        </div>

        <button onClick={logout}
          style={{ background: "none", border: "1px solid #D1D5DB",
                   color: "#6B7280", padding: "9px 28px",
                   borderRadius: "8px", cursor: "pointer",
                   fontSize: ".88rem", fontWeight: "600" }}>
          Sign out
        </button>
      </div>
    </div>
  );
}
